var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedbackBlack = function SvgFeedbackBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    d: "M4.8 4.25h14.4c.58 0 1.05.47 1.05 1.05v10.8c0 .58-.47 1.05-1.05 1.05H7.346a2.55 2.55 0 0 0-1.804.747L3.75 19.689V5.299c0-.579.47-1.049 1.05-1.049Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.012 6.95v3.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.5,
    r: 0.662,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.676
  })));
};
export default SvgFeedbackBlack;